module.exports = __webpack_public_path__ + "img/squiggle-dots.2d051a69.svg";